/* eslint-disable no-shadow */
export enum SceneType {
  Both = 'BOTH',
  Static = 'STATIC',
  Playground = 'PLAYGROUND'
}
